import { LRSProvider, useLRSContext } from 'contexts';
import type { DocumentsCollection } from 'models/documentsCollection';
import type { Transaction } from 'models/transaction';
import { useTranslations } from 'utils/translations/useTranslations';

function Step() {
  const { steps, index } = useLRSContext();
  return steps[index].element;
}

type LRSProps = {
  allCollectionFilesUploaded: boolean;
  documentsCollection: DocumentsCollection[];
  idVerificationNeeded: boolean;
  initialValues: Record<string, string>;
  isStudentPaying: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  paymentId: string;
  previousTransactions: Transaction[];
};

function LRS({
  allCollectionFilesUploaded = false,
  documentsCollection = [],
  idVerificationNeeded = true,
  initialValues = {},
  isStudentPaying = false,
  onCancel,
  onSubmit,
  paymentId,
  previousTransactions = [],
}: LRSProps) {
  const i18n = useTranslations();

  return (
    <div data-testid="lrs-container" className="contents">
      <LRSProvider
        allCollectionFilesUploaded={allCollectionFilesUploaded}
        documentsCollection={documentsCollection}
        i18n={i18n}
        idVerificationNeeded={idVerificationNeeded}
        initialValues={initialValues}
        isStudentPaying={isStudentPaying}
        onCancel={onCancel}
        onSubmit={onSubmit}
        paymentId={paymentId}
        previousTransactions={previousTransactions}
      >
        <Step />
      </LRSProvider>
    </div>
  );
}

export { LRS };
